module.exports = __webpack_public_path__ + "Kanit-Regular.dee71812c8870b4c5ec6.ttf";


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/assets/fonts/Kanit-Regular.ttf
// module id = ../../../../../src/assets/fonts/Kanit-Regular.ttf
// module chunks = styles